import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(0);
  const [selectedColor, setSelectedColor] = useState(0);
  const [selectedImage, setSelectedImage] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(
      product.id,
      quantity,
      product?.size?.[selectedSize] || "",
      product?.colors?.[selectedColor] || ""
    );
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <div className="product-detail__content">
          <div className="product-detail__image-section">
            <div className="product-detail__main-image">
              <img
                src={product.images?.[selectedImage] || product.image}
                alt={product.name}
              />
            </div>
            <div className="product-detail__thumbnails">
              {product.images?.map((img, idx) => (
                <div
                  key={idx}
                  className={`product-detail__thumbnail ${
                    idx === selectedImage ? "active" : ""
                  }`}
                  onClick={() => setSelectedImage(idx)}
                >
                  <img src={img || product.image} alt={product.name} />
                </div>
              ))}
            </div>
          </div>
          <div className="product-detail__info-section">
            <div className="product-detail__brand">
              {product.brand || "tunrisefield"}
            </div>
            <h1 className="product-detail__title">{product.name}</h1>
            <p className="product-detail__price">${product.price}</p>
            <p className="product-detail__shipping">
              Shipping calculated at checkout.
            </p>

            {product.size && product.size.length > 0 && (
              <div className="product-detail__options-section">
                <p className="product-detail__options-label">Size</p>
                <div className="product-detail__options">
                  {product.size.map((size, idx) => (
                    <div
                      key={idx}
                      className={`product-detail__option ${
                        idx === selectedSize ? "active" : ""
                      }`}
                      onClick={() => setSelectedSize(idx)}
                    >
                      {size}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {product.colors && product.colors.length > 0 && (
              <div className="product-detail__options-section">
                <p className="product-detail__options-label">Color</p>
                <div className="product-detail__options">
                  {product.colors.map((color, idx) => (
                    <div
                      key={idx}
                      className={`product-detail__option ${
                        idx === selectedColor ? "active" : ""
                      }`}
                      onClick={() => setSelectedColor(idx)}
                    >
                      {color}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="product-detail__quantity-section">
              <p className="product-detail__quantity-label">Quantity</p>
              <div className="product-detail__quantity-controls">
                <button
                  className="product-detail__quantity-btn"
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                >
                  −
                </button>
                <span className="product-detail__quantity-value">
                  {quantity}
                </span>
                <button
                  className="product-detail__quantity-btn"
                  onClick={() => setQuantity(quantity + 1)}
                >
                  +
                </button>
              </div>
            </div>

            <div className="product-detail__actions">
              <button
                className="product-detail__add-to-cart"
                onClick={handleAddToCart}
              >
                Add to cart
              </button>
            </div>

            {product.description && product.description.length > 0 && (
              <div className="product-detail__description">
                <h3 className="product-detail__section-title">Description</h3>
                <div className="product-detail__description-content">
                  {product.description.map((text, idx) => (
                    <p key={idx}>{text}</p>
                  ))}
                </div>
              </div>
            )}

            {product.Features && product.Features.length > 0 && (
              <div className="product-detail__features">
                <h3 className="product-detail__section-title">Features</h3>
                <ul className="product-detail__features-list">
                  {product.Features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            )}

            <p className="product-detail__terms">
              By placing your order, you agree to tunrisefield's{" "}
              <Link onClick={toTop} to="/terms">
                Terms and Conditions
              </Link>{" "}
              and{" "}
              <Link onClick={toTop} to="/privacy">
                Privacy Policy
              </Link>
              . Order information is used only as described in these policies.
            </p>

            <div className="product-detail__footer-text">
              Selected for a smooth, dependable writing experience
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
